import pkg from '../../../../package.json';

export const environment = {
  production: false,
  apiUrl: 'https://api.v2.dev.activar.app/',
  paymentsUrl: 'https://pagos.dev.activar.app/',
  authUrl: 'https://auth.dev.activar.app/',
  gleapApiKey: 'CrhxhGFBEHsZbsBPkpPSY6L2HAQCgSLA',
  version: pkg.version,
  recaptchaSiteKey: '6Lf96GEtAAAAAH3cGXQ7Yzg2gZWVlMplO4MsNBFf',
};
